// extracted by mini-css-extract-plugin
export var wrapper = "LanguageSwitcher-module--wrapper--Joq+n";
export var langIcon = "LanguageSwitcher-module--langIcon--ja7Xa";
export var isWhite = "LanguageSwitcher-module--isWhite--GHF4A";
export var selectValue = "LanguageSwitcher-module--selectValue--FrMLP";
export var selectList = "LanguageSwitcher-module--selectList--GXLzI";
export var selectItem = "LanguageSwitcher-module--selectItem--AYkm+";
export var whiteDropDown = "LanguageSwitcher-module--whiteDropDown--SzFV5";